import React from 'react';
import LegalDocLayout from '../../components/ChinaDolphins/LegalDocLayout/LegalDocLayout';

const TOC = [
  { id: 'intl-compliance', label: '1. International Regulatory Compliance' },
  { id: 'data-categories', label: '2. Data Categories Collected' },
  { id: 'information-masking', label: '3. Information Masking & Protected Structure' },
  { id: 'data-retention', label: '4. Data Storage & Record Retention' },
  { id: 'anti-circumvention-monitoring', label: '5. Anti-Circumvention & Communication Monitoring' },
  { id: 'cookies-tracking', label: '6. Cookies & Tracking Technologies' },
  { id: 'compliance-contact', label: '7. Compliance & Legal Contact' },
];

export const PrivacyPolicyContent = () => (
  <div>
    <p>
      Welcome to <strong>ChinaDolphins</strong>. This Privacy Policy explains how <strong>MTN GLOBAL LIMITED</strong>,
      incorporated in Hong Kong, together with its operational activities in Guangzhou, China, collects, protects, uses,
      and manages personal and corporate information across the ChinaDolphins B2B sourcing ecosystem.
    </p>
    <p>
      By registering an account or using ChinaDolphins services, users acknowledge and consent to the data-processing practices described in this policy.
    </p>

    <h2 id="intl-compliance">1. International Regulatory Compliance</h2>
    <p>
      The platform operates across international markets and processes cross-border trade data. ChinaDolphins adheres to the following major data-protection frameworks:
    </p>
    <ul>
      <li><strong>GDPR:</strong> General Data Protection Regulation for European Union enterprises and individuals.</li>
      <li><strong>CCPA / CPRA:</strong> California Consumer Privacy Act requirements where applicable.</li>
      <li><strong>PIPL:</strong> Personal Information Protection Law of the People&apos;s Republic of China relating to mainland participants and processing activities.</li>
    </ul>

    <h2 id="data-categories">2. Data Categories Collected</h2>
    <h3>2.1 Global Buyers</h3>
    <ul>
      <li>Corporate registration information, company name, country, and tax ID numbers.</li>
      <li>Billing and shipping addresses for logistics and customs clearance.</li>
      <li>Identity and KYC (Know Your Customer) documentation where required by financial partners.</li>
      <li>IP address, device metadata, order histories, and payment and transaction information processed through approved third-party payment providers.</li>
    </ul>

    <h3>2.2 Sourcing Agents &amp; Manufacturing Factories</h3>
    <ul>
      <li>Chinese business licences (营业执照) and corporate legal representative information.</li>
      <li>Factory location, production capabilities, capacity, and workshop verification data.</li>
      <li>Corporate banking and settlement details required for payment processing via approved third-party providers.</li>
    </ul>

    <h3>2.3 Platform Activity</h3>
    <ul>
      <li>On-platform messaging, RFQs, quotations, order aggregation participations, and support ticket records.</li>
    </ul>

    <h2 id="information-masking">3. Information Masking &amp; Protected Marketplace Structure</h2>
    <p>
      ChinaDolphins utilizes a protected marketplace structure to ensure secure trade, fraud prevention, and operational integrity.
    </p>
    <p>
      Global Buyers and Manufacturing Factories are not provided unrestricted access to each other&apos;s direct contact details.
    </p>
    <ul>
      <li><strong>Protected Factory Information:</strong> Legal company name (where restricted by policy), direct physical address, direct telephone numbers, emails, websites, and WeChat IDs.</li>
      <li><strong>Operational Access:</strong> Assigned verified Sourcing Agents receive necessary operational credentials to coordinate factory production, quality inspections, and export clearance.</li>
    </ul>

    <h2 id="data-retention">4. Data Storage &amp; Record Retention</h2>
    <p>
      Personal and corporate information is stored using industry-standard AES encryption and SSL/TLS transmission protocols.
    </p>
    <p>
      Where a valid data-deletion request is submitted, personal credentials may be anonymized or purged, subject to statutory record-retention requirements for cross-border customs declarations, tax invoices, and AML audit records.
    </p>

    <h2 id="anti-circumvention-monitoring">5. Anti-Circumvention &amp; Communication Monitoring</h2>
    <p>
      To safeguard participants and maintain platform compliance, on-platform messaging and RFQ exchanges may be programmatically analyzed and manually reviewed for anti-circumvention triggers, such as:
    </p>
    <ul>
      <li>Unsolicited sharing of private phone numbers, personal email addresses, or WeChat IDs.</li>
      <li>Requests to conduct direct off-platform wire transfers or unmonitored settlement channels.</li>
      <li>Attempts to solicit direct factory relationships bypassing the assigned Sourcing Agent.</li>
    </ul>

    <h2 id="cookies-tracking">6. Cookies &amp; Tracking Technologies</h2>
    <p>
      ChinaDolphins utilizes essential session cookies and analytics cookies to maintain authenticated login sessions, remember language and currency preferences, track active aggregation pools, and enhance interface responsiveness.
    </p>

    <h2 id="compliance-contact">7. Compliance &amp; Legal Contact</h2>
    <p>
      For privacy inquiries, data subject access requests (DSAR), or regulatory questions, please contact our Compliance Division:
    </p>
    <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '12px' }}>
      <p style={{ margin: '0 0 6px' }}><strong>MTN GLOBAL LIMITED — Compliance Division</strong></p>
      <p style={{ margin: '0 0 6px' }}>Legal Corporate Jurisdiction: Hong Kong</p>
      <p style={{ margin: '0 0 6px' }}>Operational Supply Chain Support: Guangzhou, Guangdong Province, Mainland China</p>
      <p style={{ margin: 0 }}>Official Inquiries: <a href="mailto:compliance@chinadolphin.com" style={{ color: '#2563eb' }}>compliance@chinadolphin.com</a></p>
    </div>
  </div>
);

const PrivacyPolicyPage = () => {
  return (
    <LegalDocLayout
      title="Privacy & Data Policy"
      subtitle="International data governance, information masking, and security practices across the ChinaDolphins ecosystem."
      effectiveDate="January 1, 2026"
      lastUpdated="August 9, 2026"
      jurisdiction="Hong Kong / International (MTN GLOBAL LIMITED)"
      tocItems={TOC}
    >
      <PrivacyPolicyContent />
    </LegalDocLayout>
  );
};

export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';
export const PrivacyPolicyPageComponent = PrivacyPolicyPage;
export default PrivacyPolicyPage;
